namespace SP {
    export interface PackagingInfo {
        id: string;
        barcode: string;
        name: string;
        purchasingNumber: string;
        width: number;
        height: number;
        debth: number;
        weight: number;
        price: number;
        active: boolean;
    }
}